'use client';

import { useSearchParams } from 'next/navigation';

import { ShopifyQueryParam } from '~/constants/ShopifyQueryParams';

export const useShopifyProductId = () => {
  const searchParams = useSearchParams();

  return searchParams.get(ShopifyQueryParam.Id);
};
